
import { roomData, roomDataPlanType, HotelAllRoomSearchResponse, hotelData } from '../types/Hotel';

export const filterHiddenPlans = (roomList: roomData[], hiddenPlanCodes?: string): roomData[] => {
  if (!hiddenPlanCodes || !roomList) {
    return roomList;
  }

  const hiddenCodesArray = hiddenPlanCodes.split(',').map(code => code.trim());

  const filteredRoomList = roomList.map(room => {
    if (!room.plan_list || room.plan_list.length === 0) {
      return room;
    }

    const filteredPlanList = room.plan_list.filter((plan: roomDataPlanType) => {
      const planCode = plan.plan_code;

      if (!planCode) {
        return true;
      }

      const isHidden = hiddenCodesArray.includes(String(planCode));
      return !isHidden;
    });

    return {
      ...room,
      plan_list: filteredPlanList,
    };
  });

  const finalRoomList = filteredRoomList.filter(room => 
    room.plan_list && room.plan_list.length > 0
  );

  return finalRoomList;
};

export function filterHotelDataPlans(hotelData: HotelAllRoomSearchResponse, hiddenPlanCodes?: string): HotelAllRoomSearchResponse;
export function filterHotelDataPlans(hotelData: hotelData, hiddenPlanCodes?: string): hotelData;
export function filterHotelDataPlans(hotelData: HotelAllRoomSearchResponse | hotelData, hiddenPlanCodes?: string): HotelAllRoomSearchResponse | hotelData {
  if (!hotelData || !hiddenPlanCodes) {
    return hotelData;
  }

  return {
    ...hotelData,
    room_list: filterHiddenPlans(hotelData.room_list as roomData[], hiddenPlanCodes) as any
  };
};

export const isHiddenPlan = (planCode: string | undefined, hiddenPlanCodes?: string): boolean => {
  if (!hiddenPlanCodes || !planCode) {
    return false;
  }

  const hiddenCodesArray = hiddenPlanCodes.split(',').map(code => code.trim());
  const isHidden = hiddenCodesArray.includes(String(planCode));

  return isHidden;
};